import script from "./HoursDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./HoursDetail.vue?vue&type=script&setup=true&lang=js"

import "./HoursDetail.vue?vue&type=style&index=0&id=9ce70c5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ce70c5e"]])

export default __exports__